import Swal from "sweetalert2";


export function confirmClosePopup() {
    return base({
      title: `정말 나가시겠습니까? <br> 변경사항은 저장되지 않습니다.`,
      confirmButtonText: "네",
      cancelButtonText: "아니오",
      icon: "warning",
    }).then((result) => {
      if (result.isConfirmed) {
        return true;
      }
      return false;
    });
  }

export function confirmTempSavePopup() {
  return base({
    title: `임시저장 하시겠습니까?`,
    confirmButtonText: "네",
    cancelButtonText: "아니오",
    icon: "warning",
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    }
    return false;
  });
}

export function confirmSubmitPopup() {
  return base({
    title: `최종 제출 하시겠습니까?`,
    confirmButtonText: "네",
    cancelButtonText: "아니오",
    icon: "warning",
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    }

    return false;
  });
}

function base(descriptions) {
  return Swal.fire({
    title: descriptions.title,
    html: descriptions.html,
    confirmButtonText: descriptions.confirmButtonText,
    cancelButtonText: descriptions.cancelButtonText,
    icon: descriptions.icon,
    showCancelButton: true,
    confirmButtonClass: "md-button md-warning btn-fill",
    cancelButtonClass: "md-button md-danger btn-fill",
    confirmButtonColor: "orange",
    buttonsStyling: true,
    preConfirm: descriptions.preConfirm
  });
}

export function success() {
  return Swal.fire({
    title: "완료하였습니다",
    icon: "success",
    iconColor: "orange",
    confirmButtonClass: "md-button md-success btn-fill",
    confirmButtonColor: "orange",
    buttonsStyling: true,
  });
}
